import React, { useState, useEffect } from 'react';
import CreateHavalaDialog from './report/Havala Account/CreateHavalaDialog';
import BottomDrawer from './common/BottomDrawer';
import { useAuthorization } from '../auth/useAuthorization';
import { HAVLA_CREATE } from '../auth/permissions';

/**
 * Global Create Havala dialog - opened via ALT+H. The Havala page opens its own bottom drawer for the same shortcut.
 * User role can create but not edit/delete; edit/delete are handled in HavalaAccount.
 */
const CreateHavalaGlobalDialog: React.FC = () => {
  const { hasPermission } = useAuthorization();
  const canCreateHavala = hasPermission(HAVLA_CREATE);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleOpenCreateHavala = () => {
      if (!canCreateHavala) return;
      const currentPath = window.location.pathname;
      if (currentPath === '/report/havala') return; // HavalaAccount handles it
      setIsOpen(true);
    };

    window.addEventListener('open-create-havala', handleOpenCreateHavala as EventListener);
    return () => window.removeEventListener('open-create-havala', handleOpenCreateHavala as EventListener);
  }, [canCreateHavala]);

  return (
    <BottomDrawer
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      title="Create Havala"
      maxHeight="max-h-[50vh] sm:max-h-[25vh]"
    >
      <CreateHavalaDialog
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      />
    </BottomDrawer>
  );
};

export default CreateHavalaGlobalDialog;
